/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Automation_CatInputs */

const en_svc_automation_cat = /** @type {(inputs: Svc_Automation_CatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#BOTS`)
};

const ar_svc_automation_cat = /** @type {(inputs: Svc_Automation_CatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#روبوتات`)
};

const bn_svc_automation_cat = /** @type {(inputs: Svc_Automation_CatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#BOTS`)
};

const de_svc_automation_cat = /** @type {(inputs: Svc_Automation_CatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#BOTS`)
};

const es_svc_automation_cat = /** @type {(inputs: Svc_Automation_CatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#BOTS`)
};

const fr_svc_automation_cat = /** @type {(inputs: Svc_Automation_CatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#BOTS`)
};

const pt_svc_automation_cat = /** @type {(inputs: Svc_Automation_CatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#BOTS`)
};

const zh_svc_automation_cat = /** @type {(inputs: Svc_Automation_CatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#BOTS`)
};

const tr_svc_automation_cat = /** @type {(inputs: Svc_Automation_CatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#BOTS`)
};

const ru_svc_automation_cat = /** @type {(inputs: Svc_Automation_CatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#BOTS`)
};

const pl_svc_automation_cat = /** @type {(inputs: Svc_Automation_CatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#BOTS`)
};

/**
* | output |
* | --- |
* | "#BOTS" |
*
* @param {Svc_Automation_CatInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const svc_automation_cat = /** @type {((inputs?: Svc_Automation_CatInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Automation_CatInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_automation_cat(inputs)
	if (locale === "bn") return bn_svc_automation_cat(inputs)
	if (locale === "de") return de_svc_automation_cat(inputs)
	if (locale === "es") return es_svc_automation_cat(inputs)
	if (locale === "fr") return fr_svc_automation_cat(inputs)
	if (locale === "pt") return pt_svc_automation_cat(inputs)
	if (locale === "zh") return zh_svc_automation_cat(inputs)
	if (locale === "tr") return tr_svc_automation_cat(inputs)
	if (locale === "ru") return ru_svc_automation_cat(inputs)
	if (locale === "pl") return pl_svc_automation_cat(inputs)
	return en_svc_automation_cat(inputs)
});